var _style, _g, _pattern, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.7 113.7",
    style: {
      enableBackground: "new 0 0 113.7 113.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FC8DE4;}\n\t.st2{fill:#F4068F;}\n\t.st3{fill:#AD0088;}\n\t.st4{fill:#243FFF;}\n\t.st5{fill:#F9A7E9;}\n\t.st6{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st7{fill:url(#);}\n\t.st8{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("pattern", {
    x: 509.8,
    y: -454.7,
    width: 2126,
    height: 907.1,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern_5",
    viewBox: "858.1 -1432.2 2126 907.1",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 858.1,
    y: -1432.2,
    className: "st0",
    width: 2126,
    height: 907.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2387.9-462.1c-41.9-8.1-139-26.7-203.4-107.9c-97.6-123.1-58.9-313,12.5-427.5 c63.7-102.3,154.4-145.9,273.9-203.4c147.4-70.9,253.6-121.9,348.6-83c153.1,62.6,224.5,336.9,141.1,539.5 C2864.4-510.4,2583.7-424.4,2387.9-462.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2757.7-830.5c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C2703.8-895.1,2760.9-833.6,2757.7-830.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2766-814l-0.7-0.7L2766-814c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.1-46.3-31-77.7-31 c-20,0-46,13.4-77.1,39.8c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c1.4,1.4,58.3,7.3,109.4,9.9 c16.3,0.8,33.8,1.4,50.6,1.4C2725.6-802.7,2757.3-805.3,2766-814z M2648.2-892.9c30.8,0,58.6,16.6,76.5,30.6 c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0c-6.7,6.7-33.6,13.8-123.2,9.4c-50.4-2.5-99.3-7.7-108.5-9.3 C2542-825.4,2604.7-892.9,2648.2-892.9z M2531.5-815.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2757.7-796.6c-4.9-4.9-97.3-9.7-110-9.7c-25.9,0-116.4-7.4-117.2-6.6c0,0,69.4,72.1,114.4,75.9 C2703.8-732,2760.9-793.5,2757.7-796.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2725.9-763.2c20.7-16.2,36-34.9,39.9-44.2c1.1-2.8,1.2-4.6,0.2-5.6c-12.8-12.8-75.8-12.5-126.3-9.9 c-51.1,2.6-108,8.5-109.4,9.9l-0.7,0.7l0.6,0.7c0.2,0.2,17.7,20.1,40.8,39.7c31.1,26.4,57.1,39.8,77.1,39.8 C2679.6-732.2,2707.8-749.1,2725.9-763.2z M2641.4-821.1c89.6-4.4,116.5,2.7,123.2,9.4l0,0c0.2,0.2,0.3,1.1-0.6,3.5 c-5.4,13-26.2,33.2-39.3,43.4c-17.9,14-45.7,30.6-76.5,30.6c-43.4,0-106.1-67.5-115.3-77.6 C2542.1-813.3,2591-818.6,2641.4-821.1z M2531.5-811.5L2531.5-811.5L2531.5-811.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3025.8-696.2c-0.4-0.9-42.1-93.3-108.1-184.5c-38.8-53.6-78.3-96.3-117.4-127c-49-38.4-97.5-57.8-144.1-57.8 c-46.7,0-95.2,19.5-144.1,57.8c-39.1,30.6-78.6,73.4-117.4,127c-66,91.2-107.7,183.6-108.1,184.5l-0.6,1.4h740.6L3025.8-696.2z  M2396.2-879.6c38.7-53.4,78.1-96,117-126.5c48.6-38.1,96.7-57.4,142.9-57.4s94.3,19.3,142.9,57.4c39,30.5,78.3,73.1,117,126.5 c61.5,84.9,101.8,170.8,107.3,182.8h-734.4C2294.4-708.8,2334.8-794.7,2396.2-879.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2638.8-952.9c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.2-46.3-31-77.7-31c-20,0-46,13.4-77.1,39.8 c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c2.8,2.8,69.7,46.9,117.8,46.9C2543.7-905.9,2614-928.1,2638.8-952.9z  M2520.9-1031.7c30.8,0,58.6,16.6,76.5,30.6c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0 c-24.4,24.4-93.9,46.3-116.4,46.3c-44.9,0-107.6-39.8-115.7-45.8C2412.6-961.9,2476.7-1031.7,2520.9-1031.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2630.5-969.3c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C2576.6-1033.9,2633.6-972.4,2630.5-969.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2604.8-962.6c0,14.4-11.7,26-26,26s-26-11.7-26-26C2552.7-977,2604.8-977,2604.8-962.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2890.8-952.9c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.2-46.3-31-77.7-31c-20,0-46,13.4-77.1,39.8 c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c2.8,2.8,69.7,46.9,117.8,46.9C2795.7-905.9,2866-928.1,2890.8-952.9z  M2772.9-1031.7c30.8,0,58.6,16.6,76.5,30.6c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0 c-24.4,24.4-93.9,46.3-116.4,46.3c-44.9,0-107.6-39.8-115.7-45.8C2664.6-961.9,2728.7-1031.7,2772.9-1031.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2882.5-969.3c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C2828.6-1033.9,2885.6-972.4,2882.5-969.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2856.8-962.6c0,14.4-11.7,26-26,26s-26-11.7-26-26C2804.7-977,2856.8-977,2856.8-962.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2565.8-1038.7c-18.8-7.4-33.2-21.5-39.7-38.5c-4.6-12.1-4.5-24.4,0.2-33.7c8-15.9,31.7-25.3,51.7-20.3 c3.6,0.9,6.9,2.2,10,3.8c-5.1,4.1-9.8,9-13.7,14.6c-9,12.7-12,26.1-8,35.9c3.2,8,13.7,18.4,32.8,21.7c12,2.1,21.8-0.1,26.8-5.8 c5.6-6.3,6.2-18.5,1.8-32.5c-3.4-10.7-10.1-23.1-20.1-33c4.6-1.9,9.5-3,14.4-2.8c13.3,0.5,26.6,10.7,37.4,28.5 c8.1,13.3,9.9,26.9,9.9,35.9l11-0.1c-0.1-14.9-4.1-29.3-11.5-41.6c-13.1-21.5-29.1-33.1-46.4-33.8c-8-0.3-16.4,1.9-24.3,6 c-5.2-3.5-11.1-6.2-17.6-7.8c-25-6.1-53.8,5.5-64.1,26.1c-6.1,12.1-6.3,27.6-0.6,42.6c7.6,19.9,24.3,36.2,45.9,44.8 L2565.8-1038.7z M2617.2-1090.1c3.6,11.3,2.7,19.3,0.4,21.9c-1.9,2.1-7.9,3.7-16.7,2.2c-11.7-2-21.8-8.2-24.5-15 c-2.5-6.3,0.1-16,6.8-25.5c3.6-5.1,8.6-10.2,14.3-14.3C2607.5-1112.1,2614-1100.2,2617.2-1090.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2675.7-1051.4c6.1-12.1,6.3-27.6,0.6-42.6c-7.6-19.9-24.3-36.2-45.9-44.8l-4.1,10.2 c18.8,7.4,33.2,21.5,39.7,38.5c4.6,12.1,4.5,24.4-0.2,33.7c-8,15.9-31.7,25.3-51.7,20.3c-3.6-0.9-6.9-2.2-10-3.8 c5.1-4.1,9.8-9,13.7-14.6c9-12.7,12-26.1,8-35.9c-3.2-8-13.7-18.4-32.8-21.7c-12-2.1-21.8,0.1-26.8,5.8 c-5.6,6.3-6.2,18.5-1.8,32.5c3.4,10.7,10.1,23.1,20.1,33c-4.6,1.9-9.5,3-14.4,2.8c-13.3-0.5-26.6-10.7-37.4-28.5 c-8.1-13.3-9.9-26.9-9.9-35.9l-11,0.1c0.1,14.9,4.1,29.3,11.5,41.6c13,21.5,29.1,33.2,46.4,33.8c8,0.3,16.4-1.9,24.3-6 c5.2,3.5,11.1,6.2,17.6,7.8c4.5,1.1,9.2,1.6,13.8,1.6C2646.3-1023.7,2667.2-1034.6,2675.7-1051.4z M2591.2-1101.3 c11.7,2,21.8,8.2,24.5,15c2.5,6.3-0.1,16-6.8,25.5c-3.6,5.1-8.6,10.2-14.3,14.3c-9.9-8.6-16.5-20.6-19.6-30.6 c-3.6-11.3-2.7-19.3-0.4-21.9c1.4-1.5,4.9-2.8,10.1-2.8C2586.6-1101.9,2588.8-1101.7,2591.2-1101.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2293.6-783.1c-0.7,0-1.4,0-2.1-0.1c-13.6-1.3-26.8-15.6-27.8-30.1c-0.7-9.8,4.3-16.1,8.7-21.6 c3.9-4.9,7.3-9.1,7.5-15.9c0.6-13.6-9.3-25.8-18-26.8c-9.5-1.2-17.6,9.6-17.7,9.8c-8.7,11.8-2.8,26.5-2.6,27.2l-10.2,4.2 c-0.9-2.2-8.3-21.5,3.9-37.9c1.2-1.6,12.4-16,27.9-14.1c16.6,2,28.3,21.9,27.6,38.2c-0.4,10.4-5.7,17-9.9,22.3 c-4.3,5.4-6.7,8.7-6.3,14c0.6,9.1,9.6,19.1,17.8,19.8c4.1,0.4,9-1.6,13.4-5.4c8.3-7.2,13.5-19.2,14.3-32.8l11,0.6 c-0.9,16.6-7.5,31.4-18,40.6C2307.1-786,2300.2-783.1,2293.6-783.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2177.9,
    y: -853.1,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1216.8079 1304.619)",
    className: "st2",
    width: 11,
    height: 72.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2154.3,
    y: -912.3,
    className: "st2",
    width: 11,
    height: 79.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2195.5,
    y: -925.2,
    transform: "matrix(0.8886 -0.4586 0.4586 0.8886 652.1542 910.6342)",
    className: "st2",
    width: 11,
    height: 75.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2237.5-652c-6.6,0-17.5-1.5-24.2-10.1c-10.3-13.2-4.5-35.5,7.5-46.5c7.6-7,16-8,22.8-8.7 c6.8-0.8,10.9-1.4,14.4-5.4c6-6.8,6.7-20.3,1.4-26.6c-2.6-3.2-7.5-5.2-13.2-5.7c-11-0.8-23.1,4-33.3,13.1l-7.4-8.2 c12.4-11.1,27.5-16.9,41.4-15.9c8.9,0.6,16.3,4.1,20.9,9.6c8.7,10.5,7.9,30-1.6,40.9c-6.5,7.4-14.4,8.3-21.4,9.1 c-6.2,0.7-11.6,1.3-16.6,5.9c-10,9.2-11.6,24.8-6.3,31.7c5.9,7.5,19.3,5.6,19.4,5.6c14.5-2.1,20.8-16.8,21-17.4l10.2,4.2 c-0.9,2.1-9.3,21-29.6,24C2242.3-652.3,2240.3-652,2237.5-652z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2284.3,
    y: -661.8,
    className: "st2",
    width: 72.9,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2292.2,
    y: -639.5,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1097.0403 1448.9537)",
    className: "st2",
    width: 11,
    height: 79.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2252.7,
    y: -656.5,
    transform: "matrix(0.3041 -0.9526 0.9526 0.3041 2160.9124 1720.7407)",
    className: "st2",
    width: 11,
    height: 75.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2539.2-611.4c-8,0-16.3-2.6-22.1-7.7c-7.4-6.5-8.3-14.4-9.1-21.4c-0.7-6.2-1.3-11.6-5.9-16.6 c-9.2-10-24.8-11.6-31.7-6.3c-7.5,5.9-5.6,19.3-5.6,19.4c2.1,14.5,16.8,20.8,17.4,21l-4.2,10.1c-2.1-0.9-21-9.3-24-29.6 c-0.3-2-2.6-20.1,9.7-29.7c13.2-10.3,35.5-4.5,46.5,7.5c7,7.6,8,16,8.7,22.8c0.8,6.8,1.4,10.9,5.4,14.4 c6.8,6,20.3,6.7,26.6,1.4c3.2-2.6,5.2-7.5,5.7-13.2c0.8-11-4-23.1-13.1-33.3l8.2-7.4c11.1,12.4,16.9,27.5,15.9,41.4 c-0.6,8.9-4.1,16.3-9.6,20.9C2553.1-613.4,2546.2-611.4,2539.2-611.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2452.3,
    y: -601,
    className: "st2",
    width: 11,
    height: 72.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2361.9,
    y: -593,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1118.8431 1526.0087)",
    className: "st2",
    width: 79.2,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2382.4,
    y: -632.5,
    transform: "matrix(0.304 -0.9527 0.9527 0.304 2281.7373 1869.274)",
    className: "st2",
    width: 75.7,
    height: 11
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2376.1,
    y: -996.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1405.0791 1409.6094)",
    className: "st2",
    width: 56,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.4,
    y: -1018.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1427.7992 1421.1377)",
    className: "st2",
    width: 56,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2838.9,
    y: -1066.2,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1567.0743 1707.1031)",
    className: "st2",
    width: 11,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2867.4,
    y: -1047.8,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1562.4017 1732.6956)",
    className: "st2",
    width: 11,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2235.5-1135c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C2311.9-1170.2,2254.1-1124.6,2235.5-1135z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2036.2-834.3c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C2112.6-869.5,2054.8-823.9,2036.2-834.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2948.4-1212.8c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C3024.8-1247.9,2967-1202.3,2948.4-1212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3001.9-587.7c-23.9-3.7-57.8-5.9-96.7,2c-81.8,16.6-133.1,66.6-152.8,88.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2124-336.3c13.7-20,30.3-49.5,40-88.1c20.4-80.9-2.6-148.8-13.5-175.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1324.9-8.5c-41.9-8.1-139-26.7-203.4-107.9c-97.6-123.1-58.9-313,12.5-427.5 c63.7-102.3,154.4-145.9,273.9-203.4c147.4-70.9,253.6-121.9,348.6-83c153.1,62.6,224.5,336.9,141.1,539.5 C1801.4-56.9,1520.7,29.1,1324.9-8.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1962.8-242.7c-0.4-0.9-42.1-93.3-108.1-184.5c-38.8-53.6-78.3-96.3-117.4-127c-49-38.4-97.5-57.8-144.1-57.8 c-46.7,0-95.2,19.5-144.1,57.8c-39.1,30.6-78.6,73.4-117.4,127c-66,91.2-107.7,183.6-108.1,184.5l-0.6,1.4h740.6L1962.8-242.7z  M1333.2-426.1c38.7-53.4,78.1-96,117-126.5c48.6-38.1,96.7-57.4,142.9-57.4s94.3,19.3,142.9,57.4c39,30.5,78.3,73.1,117,126.5 c61.5,84.9,101.8,170.8,107.3,182.8h-734.4C1231.4-255.2,1271.8-341.2,1333.2-426.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1575.8-499.3c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.2-46.3-31-77.7-31c-20,0-46,13.4-77.1,39.8 c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c2.8,2.8,69.7,46.9,117.8,46.9C1480.7-452.4,1551-474.6,1575.8-499.3z  M1457.9-578.2c30.8,0,58.6,16.6,76.5,30.6c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0 c-24.4,24.4-93.9,46.3-116.4,46.3c-44.9,0-107.6-39.8-115.7-45.8C1349.6-508.3,1413.7-578.2,1457.9-578.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.5-515.7c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C1513.6-580.4,1570.6-518.9,1567.5-515.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1827.8-499.3c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.2-46.3-31-77.7-31c-20,0-46,13.4-77.1,39.8 c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c2.8,2.8,69.7,46.9,117.8,46.9C1732.7-452.4,1803-474.6,1827.8-499.3z  M1709.9-578.2c30.8,0,58.6,16.6,76.5,30.6c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0 c-24.4,24.4-93.9,46.3-116.4,46.3c-44.9,0-107.6-39.8-115.7-45.8C1601.6-508.3,1665.7-578.2,1709.9-578.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819.5-515.7c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C1765.6-580.4,1822.6-518.9,1819.5-515.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1502.8-585.1c-18.8-7.4-33.2-21.5-39.7-38.5c-4.6-12.1-4.5-24.4,0.2-33.7c8-15.9,31.7-25.3,51.7-20.3 c3.6,0.9,6.9,2.2,10,3.8c-5.1,4.1-9.8,9-13.7,14.6c-9,12.7-12,26.1-8,35.9c3.2,8,13.7,18.4,32.8,21.7c12,2.1,21.8-0.1,26.8-5.8 c5.6-6.3,6.2-18.5,1.8-32.5c-3.4-10.7-10.1-23.1-20.1-33c4.6-1.9,9.5-3,14.4-2.8c13.3,0.5,26.6,10.7,37.4,28.5 c8.1,13.3,9.9,26.9,9.9,35.9l11-0.1c-0.1-14.9-4.1-29.3-11.5-41.6c-13.1-21.5-29.1-33.1-46.4-33.8c-8-0.3-16.4,1.9-24.3,6 c-5.2-3.5-11.1-6.2-17.6-7.8c-25-6.1-53.8,5.5-64.1,26.1c-6.1,12.1-6.3,27.6-0.6,42.6c7.6,19.9,24.3,36.2,45.9,44.8 L1502.8-585.1z M1554.2-636.6c3.6,11.3,2.7,19.3,0.4,21.9c-1.9,2.1-7.9,3.7-16.7,2.2c-11.7-2-21.8-8.2-24.5-15 c-2.5-6.3,0.1-16,6.8-25.5c3.6-5.1,8.6-10.2,14.3-14.3C1544.5-658.6,1551.1-646.7,1554.2-636.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1612.7-597.9c6.1-12.1,6.3-27.6,0.6-42.6c-7.6-19.9-24.3-36.2-45.9-44.8l-4.1,10.2 c18.8,7.4,33.2,21.5,39.7,38.5c4.6,12.1,4.5,24.4-0.2,33.7c-8,15.9-31.7,25.3-51.7,20.3c-3.6-0.9-6.9-2.2-10-3.8 c5.1-4.1,9.8-9,13.7-14.6c9-12.7,12-26.1,8-35.9c-3.2-8-13.7-18.4-32.8-21.7c-12-2.1-21.8,0.1-26.8,5.8 c-5.6,6.3-6.2,18.5-1.8,32.5c3.4,10.7,10.1,23.1,20.1,33c-4.6,1.9-9.5,3-14.4,2.8c-13.3-0.5-26.6-10.7-37.4-28.5 c-8.1-13.3-9.9-26.9-9.9-35.9l-11,0.1c0.1,14.9,4.1,29.3,11.5,41.6c13,21.5,29.1,33.2,46.4,33.8c8,0.3,16.4-1.9,24.3-6 c5.2,3.5,11.1,6.2,17.6,7.8c4.5,1.1,9.2,1.6,13.8,1.6C1583.3-570.2,1604.2-581.1,1612.7-597.9z M1528.2-647.8 c11.7,2,21.8,8.2,24.5,15c2.5,6.3-0.1,16-6.8,25.5c-3.6,5.1-8.6,10.2-14.3,14.3c-9.9-8.6-16.5-20.6-19.6-30.6 c-3.6-11.3-2.7-19.3-0.4-21.9c1.4-1.5,4.9-2.8,10.1-2.8C1523.6-648.4,1525.8-648.2,1528.2-647.8z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1313.1,
    y: -543.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 773.0192 790.7948)",
    className: "st2",
    width: 56,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1338.4,
    y: -564.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 795.7524 802.3285)",
    className: "st2",
    width: 56,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.9,
    y: -612.7,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 935.0949 1088.321)",
    className: "st2",
    width: 11,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1804.4,
    y: -594.3,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 930.4222 1113.9135)",
    className: "st2",
    width: 11,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1172.5-681.5c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C1248.9-716.6,1191.1-671.1,1172.5-681.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1885.4-759.2c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C1961.8-794.4,1904-748.8,1885.4-759.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1940.2-693c6.2,23.4,17.7,55.3,40.5,87.8c47.9,68.3,114.3,95.3,141.9,104.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.9-462.1c-41.9-8.1-139-26.7-203.4-107.9C-39.1-693.1-0.3-883,71-997.4 c63.7-102.3,154.4-145.9,273.9-203.4c147.4-70.9,253.6-121.9,348.6-83c153.1,62.6,224.5,336.9,141.1,539.5 C738.4-510.4,457.7-424.4,261.9-462.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M899.8-696.2c-0.4-0.9-42.1-93.3-108.1-184.5c-38.8-53.6-78.3-96.3-117.4-127c-49-38.4-97.5-57.8-144.1-57.8 c-46.7,0-95.2,19.5-144.1,57.8c-39.1,30.6-78.6,73.4-117.4,127c-66,91.2-107.7,183.6-108.1,184.5l-0.6,1.4h740.6L899.8-696.2z  M270.2-879.6c38.7-53.4,78.1-96,117-126.5c48.6-38.1,96.7-57.4,142.9-57.4s94.3,19.3,142.9,57.4c39,30.5,78.3,73.1,117,126.5 c61.5,84.9,101.8,170.8,107.3,182.8H163C168.5-708.8,208.8-794.7,270.2-879.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M926.1-588.7c-16.6-0.9-31.4-7.5-40.6-18c-5.8-6.7-8.7-14.4-8-21.6c1.3-13.6,15.6-26.8,30.1-27.8 c9.8-0.7,16.1,4.3,21.6,8.7c4.9,3.9,9.1,7.3,15.9,7.5c13.6,0.6,25.8-9.3,26.8-18c1.2-9.5-9.6-17.6-9.8-17.7 c-11.8-8.7-26.5-2.8-27.2-2.6l-4.2-10.2c2.2-0.9,21.5-8.3,37.9,3.9c1.6,1.2,16,12.4,14.1,27.9c-2,16.6-21.9,28.3-38.2,27.6 c-10.4-0.4-17-5.7-22.3-9.9c-5.4-4.3-8.7-6.7-14-6.3c-9.1,0.6-19.1,9.6-19.8,17.8c-0.4,4.1,1.6,9,5.4,13.4 c7.2,8.3,19.2,13.5,32.8,14.3L926.1-588.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.5,
    y: -742.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 787.6295 428.3659)",
    className: "st2",
    width: 72.9,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 927.4,
    y: -765.7,
    className: "st2",
    width: 79.2,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 943.8,
    y: -724.4,
    transform: "matrix(0.8886 -0.4586 0.4586 0.8886 439.0666 370.1529)",
    className: "st2",
    width: 75.7,
    height: 11
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M964.3-496.5c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C1040.7-531.6,983-486.1,964.3-496.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1086-820.8c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C1162.4-856,1104.6-810.4,1086-820.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M822.4-1212.8c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C898.8-1247.9,841.1-1202.3,822.4-1212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M877.2-1146.6c6.2,23.4,17.7,55.3,40.5,87.8c47.9,68.3,114.3,95.3,141.9,104.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M875.9-587.7c-23.9-3.7-57.8-5.9-96.7,2c-81.8,16.6-133.1,66.6-152.8,88.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2387.9-1369.1c-41.9-8.1-139-26.7-203.4-107.9c-97.6-123.1-58.9-313,12.5-427.5 c63.7-102.3,154.4-145.9,273.9-203.4c147.4-70.9,253.6-121.9,348.6-83c153.1,62.6,224.5,336.9,141.1,539.5 C2864.4-1417.5,2583.7-1331.5,2387.9-1369.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2340.3-1211c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C2416.6-1246.1,2358.9-1200.6,2340.3-1211z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3001.9-1494.8c-23.9-3.7-57.8-5.9-96.7,2c-81.8,16.6-133.1,66.6-152.8,88.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2124-1243.4c13.7-20,30.3-49.5,40-88.1c20.4-80.9-2.6-148.8-13.5-175.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1324.9-915.6c-41.9-8.1-139-26.7-203.4-107.9c-97.6-123.1-58.9-313,12.5-427.5 c63.7-102.3,154.4-145.9,273.9-203.4c147.4-70.9,253.6-121.9,348.6-83c153.1,62.6,224.5,336.9,141.1,539.5 C1801.4-963.9,1520.7-878,1324.9-915.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1694.7-1284c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C1640.8-1348.6,1697.9-1287.2,1694.7-1284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703-1267.6l-0.7-0.7L1703-1267.6c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.1-46.3-31-77.7-31 c-20,0-46,13.4-77.1,39.8c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c1.4,1.4,58.3,7.3,109.4,9.9 c16.3,0.8,33.8,1.4,50.6,1.4C1662.6-1256.2,1694.3-1258.9,1703-1267.6z M1585.2-1346.5c30.8,0,58.6,16.6,76.5,30.6 c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0c-6.7,6.7-33.6,13.8-123.2,9.4c-50.4-2.5-99.3-7.7-108.5-9.3 C1479-1279,1541.7-1346.5,1585.2-1346.5z M1468.5-1269.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1694.7-1250.2c-4.9-4.9-97.3-9.7-110-9.7c-25.9,0-116.4-7.4-117.2-6.6c0,0,69.4,72.1,114.4,75.9 C1640.8-1185.6,1697.9-1247,1694.7-1250.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.9-1216.8c20.7-16.2,36-34.9,39.9-44.2c1.1-2.8,1.2-4.6,0.2-5.6c-12.8-12.8-75.8-12.5-126.3-9.9 c-51.1,2.6-108,8.5-109.4,9.9l-0.7,0.7l0.6,0.7c0.2,0.2,17.7,20.1,40.8,39.7c31.1,26.4,57.1,39.8,77.1,39.8 C1616.6-1185.7,1644.8-1202.6,1662.9-1216.8z M1578.4-1274.6c89.6-4.4,116.5,2.7,123.2,9.4l0,0c0.2,0.2,0.3,1.1-0.6,3.5 c-5.4,13-26.2,33.2-39.3,43.4c-17.9,14-45.7,30.6-76.5,30.6c-43.4,0-106.1-67.5-115.3-77.6 C1479.1-1266.9,1528-1272.1,1578.4-1274.6z M1468.5-1265L1468.5-1265L1468.5-1265z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1962.8-1149.8c-0.4-0.9-42.1-93.3-108.1-184.5c-38.8-53.6-78.3-96.3-117.4-127c-49-38.4-97.5-57.8-144.1-57.8 c-46.7,0-95.2,19.5-144.1,57.8c-39.1,30.6-78.6,73.4-117.4,127c-66,91.2-107.7,183.6-108.1,184.5l-0.6,1.4h740.6L1962.8-1149.8z  M1333.2-1333.2c38.7-53.4,78.1-96,117-126.5c48.6-38.1,96.7-57.4,142.9-57.4s94.3,19.3,142.9,57.4c39,30.5,78.3,73.1,117,126.5 c61.5,84.9,101.8,170.8,107.3,182.8h-734.4C1231.4-1162.3,1271.8-1248.3,1333.2-1333.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1575.8-1406.4c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.2-46.3-31-77.7-31c-20,0-46,13.4-77.1,39.8 c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c2.8,2.8,69.7,46.9,117.8,46.9C1480.7-1359.5,1551-1381.7,1575.8-1406.4z  M1457.9-1485.3c30.8,0,58.6,16.6,76.5,30.6c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0 c-24.4,24.4-93.9,46.3-116.4,46.3c-44.9,0-107.6-39.8-115.7-45.8C1349.6-1415.4,1413.7-1485.3,1457.9-1485.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.5-1422.8c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C1513.6-1487.4,1570.6-1426,1567.5-1422.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.8-1416.2c0,14.4-11.7,26-26,26c-14.4,0-26-11.7-26-26C1489.7-1430.5,1541.8-1430.5,1541.8-1416.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1827.8-1406.4c1-1,0.9-2.9-0.2-5.6c-3.9-9.4-19.2-28.1-39.9-44.2c-18.1-14.2-46.3-31-77.7-31c-20,0-46,13.4-77.1,39.8 c-23.1,19.6-40.6,39.5-40.8,39.7l-0.6,0.7l0.7,0.7c2.8,2.8,69.7,46.9,117.8,46.9C1732.7-1359.5,1803-1381.7,1827.8-1406.4z  M1709.9-1485.3c30.8,0,58.6,16.6,76.5,30.6c13.1,10.2,33.9,30.4,39.3,43.4c1,2.4,0.8,3.3,0.6,3.5l0,0 c-24.4,24.4-93.9,46.3-116.4,46.3c-44.9,0-107.6-39.8-115.7-45.8C1601.6-1415.4,1665.7-1485.3,1709.9-1485.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819.5-1422.8c-4.9,4.9-97.3,9.7-110,9.7c-25.9,0-116.4,7.4-117.2,6.6c0,0,69.4-72.1,114.4-75.9 C1765.6-1487.4,1822.6-1426,1819.5-1422.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.8-1416.2c0,14.4-11.7,26-26,26c-14.4,0-26-11.7-26-26C1741.7-1430.5,1793.8-1430.5,1793.8-1416.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1502.8-1492.2c-18.8-7.4-33.2-21.5-39.7-38.5c-4.6-12.1-4.5-24.4,0.2-33.7c8-15.9,31.7-25.3,51.7-20.3 c3.6,0.9,6.9,2.2,10,3.8c-5.1,4.1-9.8,9-13.7,14.6c-9,12.7-12,26.1-8,35.9c3.2,8,13.7,18.4,32.8,21.7c12,2.1,21.8-0.1,26.8-5.8 c5.6-6.3,6.2-18.5,1.8-32.5c-3.4-10.7-10.1-23.1-20.1-33c4.6-1.9,9.5-3,14.4-2.8c13.3,0.5,26.6,10.7,37.4,28.5 c8.1,13.3,9.9,26.9,9.9,35.9l11-0.1c-0.1-14.9-4.1-29.3-11.5-41.6c-13.1-21.5-29.1-33.1-46.4-33.8c-8-0.3-16.4,1.9-24.3,6 c-5.2-3.5-11.1-6.2-17.6-7.8c-25-6.1-53.8,5.5-64.1,26.1c-6.1,12.1-6.3,27.6-0.6,42.6c7.6,19.9,24.3,36.2,45.9,44.8 L1502.8-1492.2z M1554.2-1543.7c3.6,11.3,2.7,19.3,0.4,21.9c-1.9,2.1-7.9,3.7-16.7,2.2c-11.7-2-21.8-8.2-24.5-15 c-2.5-6.3,0.1-16,6.8-25.5c3.6-5.1,8.6-10.2,14.3-14.3C1544.5-1565.7,1551.1-1553.7,1554.2-1543.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1612.7-1505c6.1-12.1,6.3-27.6,0.6-42.6c-7.6-19.9-24.3-36.2-45.9-44.8l-4.1,10.2 c18.8,7.4,33.2,21.5,39.7,38.5c4.6,12.1,4.5,24.4-0.2,33.7c-8,15.9-31.7,25.3-51.7,20.3c-3.6-0.9-6.9-2.2-10-3.8 c5.1-4.1,9.8-9,13.7-14.6c9-12.7,12-26.1,8-35.9c-3.2-8-13.7-18.4-32.8-21.7c-12-2.1-21.8,0.1-26.8,5.8 c-5.6,6.3-6.2,18.5-1.8,32.5c3.4,10.7,10.1,23.1,20.1,33c-4.6,1.9-9.5,3-14.4,2.8c-13.3-0.5-26.6-10.7-37.4-28.5 c-8.1-13.3-9.9-26.9-9.9-35.9l-11,0.1c0.1,14.9,4.1,29.3,11.5,41.6c13,21.5,29.1,33.2,46.4,33.8c8,0.3,16.4-1.9,24.3-6 c5.2,3.5,11.1,6.2,17.6,7.8c4.5,1.1,9.2,1.6,13.8,1.6C1583.3-1477.3,1604.2-1488.2,1612.7-1505z M1528.2-1554.8 c11.7,2,21.8,8.2,24.5,15c2.5,6.3-0.1,16-6.8,25.5c-3.6,5.1-8.6,10.2-14.3,14.3c-9.9-8.6-16.5-20.6-19.6-30.6 c-3.6-11.3-2.7-19.3-0.4-21.9c1.4-1.5,4.9-2.8,10.1-2.8C1523.6-1555.4,1525.8-1555.3,1528.2-1554.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1230.7-1236.7c-0.7,0-1.4,0-2.1-0.1c-13.6-1.3-26.8-15.6-27.8-30.1c-0.7-9.8,4.3-16.1,8.7-21.6 c3.9-4.9,7.3-9.1,7.5-15.9c0.6-13.6-9.3-25.8-18-26.8c-9.5-1.2-17.6,9.6-17.7,9.8c-8.7,11.8-2.8,26.5-2.6,27.2l-10.2,4.2 c-0.9-2.2-8.3-21.5,3.9-37.9c1.2-1.6,12.4-16,27.9-14.1c16.6,2,28.3,21.9,27.6,38.2c-0.4,10.4-5.7,17-9.9,22.3 c-4.3,5.4-6.7,8.7-6.3,14c0.6,9.1,9.6,19.1,17.8,19.8c4.1,0.4,9-1.6,13.4-5.4c8.3-7.2,13.5-19.2,14.3-32.8l11,0.6 c-0.9,16.6-7.5,31.4-18,40.6C1244.1-1239.5,1237.2-1236.7,1230.7-1236.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.9,
    y: -1306.6,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1226.1952 420.1976)",
    className: "st2",
    width: 11,
    height: 72.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1091.3,
    y: -1365.9,
    className: "st2",
    width: 11,
    height: 79.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.5,
    y: -1378.8,
    transform: "matrix(0.8886 -0.4586 0.4586 0.8886 741.7728 372.5792)",
    className: "st2",
    width: 11,
    height: 75.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1174.5-1105.5c-6.6,0-17.5-1.5-24.2-10.1c-10.3-13.2-4.5-35.5,7.5-46.5c7.6-7,16-8,22.8-8.7 c6.8-0.8,10.9-1.4,14.4-5.4c6-6.8,6.7-20.3,1.4-26.6c-2.6-3.2-7.5-5.2-13.2-5.7c-11-0.8-23.1,4-33.3,13.1l-7.4-8.2 c12.4-11.1,27.5-16.9,41.4-15.9c8.9,0.6,16.3,4.1,20.9,9.6c8.7,10.5,7.9,30-1.6,40.9c-6.5,7.4-14.4,8.3-21.4,9.1 c-6.2,0.7-11.6,1.3-16.6,5.9c-10,9.2-11.6,24.8-6.3,31.7c5.9,7.5,19.3,5.6,19.4,5.6c14.5-2.1,20.8-16.8,21-17.4l10.2,4.2 c-0.9,2.1-9.3,21-29.6,24C1179.3-1105.8,1177.3-1105.5,1174.5-1105.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1221.3,
    y: -1115.3,
    className: "st2",
    width: 72.9,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1229.2,
    y: -1093,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1106.4276 564.5323)",
    className: "st2",
    width: 11,
    height: 79.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1189.7,
    y: -1110.1,
    transform: "matrix(0.3041 -0.9526 0.9526 0.3041 1853.2241 392.4576)",
    className: "st2",
    width: 11,
    height: 75.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1989.1-1042.3c-16.6-0.9-31.4-7.5-40.6-18c-5.8-6.7-8.7-14.4-8-21.6c1.3-13.6,15.6-26.8,30.1-27.8 c9.8-0.7,16.1,4.3,21.6,8.7c4.9,3.9,9.1,7.3,15.9,7.5c13.6,0.6,25.8-9.3,26.8-18c1.2-9.5-9.6-17.6-9.8-17.7 c-11.8-8.7-26.5-2.8-27.2-2.6l-4.2-10.2c2.2-0.9,21.5-8.3,37.9,3.9c1.6,1.2,16,12.4,14.1,27.9c-2,16.6-21.9,28.3-38.2,27.6 c-10.4-0.4-17-5.7-22.3-9.9c-5.4-4.3-8.7-6.7-14-6.3c-9.1,0.6-19.1,9.6-19.8,17.8c-0.4,4.1,1.6,9,5.4,13.4 c7.2,8.3,19.2,13.5,32.8,14.3L1989.1-1042.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: -1195.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1419.6814 1047.1771)",
    className: "st2",
    width: 72.9,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1990.4,
    y: -1219.2,
    className: "st2",
    width: 79.2,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2006.8,
    y: -1178,
    transform: "matrix(0.8886 -0.4586 0.4586 0.8886 765.4708 807.1667)",
    className: "st2",
    width: 75.7,
    height: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1476.2-1064.9c-8,0-16.3-2.6-22.1-7.7c-7.4-6.5-8.3-14.4-9.1-21.4c-0.7-6.2-1.3-11.6-5.9-16.6 c-9.2-10-24.8-11.6-31.7-6.3c-7.5,5.9-5.6,19.3-5.6,19.4c2.1,14.5,16.8,20.8,17.4,21l-4.2,10.1c-2.1-0.9-21-9.3-24-29.6 c-0.3-2-2.6-20.1,9.7-29.7c13.2-10.3,35.5-4.5,46.5,7.5c7,7.6,8,16,8.7,22.8c0.8,6.8,1.4,10.9,5.4,14.4 c6.8,6,20.3,6.7,26.6,1.4c3.2-2.6,5.2-7.5,5.7-13.2c0.8-11-4-23.1-13.1-33.3l8.2-7.4c11.1,12.4,16.9,27.5,15.9,41.4 c-0.6,8.9-4.1,16.3-9.6,20.9C1490.1-1066.9,1483.2-1064.9,1476.2-1064.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1389.3,
    y: -1054.5,
    className: "st2",
    width: 11,
    height: 72.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1298.9,
    y: -1046.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1128.1998 641.5107)",
    className: "st2",
    width: 79.2,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1319.4,
    y: -1086.1,
    transform: "matrix(0.304 -0.9527 0.9527 0.304 1974.012 540.9587)",
    className: "st2",
    width: 75.7,
    height: 11
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1313.1,
    y: -1450.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1414.4342 525.1074)",
    className: "st2",
    width: 56,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1338.4,
    y: -1472,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1437.1595 536.649)",
    className: "st2",
    width: 56,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.9,
    y: -1519.8,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1576.4617 822.6818)",
    className: "st2",
    width: 11,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1804.4,
    y: -1501.3,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 1571.7891 848.2742)",
    className: "st2",
    width: 11,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1277.3-757.4c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C1353.7-792.6,1295.9-747,1277.3-757.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1172.5-1588.6c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C1248.9-1623.7,1191.1-1578.2,1172.5-1588.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M973.2-1287.9c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C1049.6-1323,991.8-1277.5,973.2-1287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2027.3-950c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C2103.7-985.2,2046-939.6,2027.3-950z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2149-1274.4c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C2225.4-1309.5,2167.6-1264,2149-1274.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1885.4-1666.3c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C1961.8-1701.4,1904-1655.9,1885.4-1666.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1940.2-1600.1c6.2,23.4,17.7,55.3,40.5,87.8c47.9,68.3,114.3,95.3,141.9,104.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1938.9-1041.3c-23.9-3.7-57.8-5.9-96.7,2c-81.8,16.6-133.1,66.6-152.8,88.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1061-789.9c13.7-20,30.3-49.5,40-88.1c20.4-80.9-2.6-148.8-13.5-175.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.9-1369.1c-41.9-8.1-139-26.7-203.4-107.9c-97.6-123.1-58.9-313,12.5-427.5 c63.7-102.3,154.4-145.9,273.9-203.4c147.4-70.9,253.6-121.9,348.6-83c153.1,62.6,224.5,336.9,141.1,539.5 C738.4-1417.5,457.7-1331.5,261.9-1369.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M964.3-1403.6c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1 C1040.7-1438.7,983-1393.1,964.3-1403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M875.9-1494.8c-23.9-3.7-57.8-5.9-96.7,2c-81.8,16.6-133.1,66.6-152.8,88.1"
  }))))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(4.280626e-02 0 0 4.280626e-02 -6626.8013 -8420.0127)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    width: 113.7,
    height: 113.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/Pattern2.c0ff98945aa74767a5b6b6b1ccf78d1d.svg";
export { ForwardRef as ReactComponent };